/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import type { CalendarDate } from '@internationalized/date';

import { DatePicker, localToday, useFlags } from 'sarsaparilla';

import { SingleDatePicker } from 'shared-ui/flex-date-picker';

interface HeroSingleDateProps {
    value: CalendarDate | null;
    onChange: (value: CalendarDate | null) => void;
    /** Accessible name for the date field. */
    label: string;
}

/**
 * Renders a homepage tab's single-date control, switching between the sarsa
 * DatePicker and the new SingleDatePicker on the `newSearchDatePicker` flag.
 */
export function HeroSingleDate({ value, onChange, label }: HeroSingleDateProps) {
    const { newSearchDatePicker } = useFlags();

    if (newSearchDatePicker) {
        return (
            <div className="mr-1">
                <SingleDatePicker
                    value={value}
                    onChange={onChange}
                    label={label}
                    size="lg"
                    popoverAlign="end"
                />
            </div>
        );
    }

    return (
        <DatePicker
            className="hero-date-picker"
            size="lg"
            label={label}
            isLabelVisible={false}
            minValue={localToday}
            value={value}
            onChange={onChange}
        />
    );
}
